
import axios from 'axios';
import * as constants from "./constants";

const axiosMainUrl = axios.create({
    baseURL: constants.baseURL
});

axiosMainUrl.interceptors.request.use((config) => {
    const token = localStorage.getItem('token');
    if (token) {
        config.headers.Authorization = `Bearer ${token}`;
    }
    config.headers["Content-Type"] = `application/json`;
    return config;
})

export const getAllClients = async () => {
    try {
        return await axiosMainUrl.get("/client/all");
    }
    catch (err) {
        console.log(err);
    }
}

export const addClient = async (formData) => {
    try {
        return await axiosMainUrl.post("/client/create", formData);
    }
    catch (err) {
        console.log(err);
    }
}

export const createConfiguration = async (formData) => {
    try {
        return await axiosMainUrl.post("/configuration/create", formData);
    }
    catch (err) {
        console.log(err);
    }
}

export const findConfiguration = async (id) => {
    try {
        return await axiosMainUrl.get(`/configuration/client/${id}`);
    }
    catch (err) {
        console.log(err);
    }
}

export const deleteUser = async (facebookId) => {
    try {
        return await axiosMainUrl.delete(`/client/delete/facebookProfileId/${facebookId}`);
    }
    catch (err) {
        console.log(err);
    }
}

export const editUser = async (formData) => {
    try {
        return await axiosMainUrl.put("/client/update", formData);
    }
    catch (err) {
        console.log(err);
    }
}

export const updateUser = async (formData) => {
    try{
        return await axiosMainUrl.put(`/client/update`, formData);
    }
    catch (err) {
        console.log(err);
    }
}

export const sendPostFiles = async (formData) => {
    try {
        return await axios.post(`https://test.prorecrm.com:8089/webhook/pictures/upload`, formData);
    }
    catch (e) {
        console.log(e);
    }
}

export const getPostFiles = async (url) => {
    try {
        return await axios.get(`https://prorecrm.com/images/upload`);
    }
    catch (err) {
        console.log(err);
    }
}

export const sendPost = async (form) => {
    try {
        return await axiosMainUrl.post("/post/create", form);
    }
    catch (err) {
        console.log(err);
    }
}

export const getAllPosts = async () => {
    try {
        return await axiosMainUrl.get("/post/get-posts");
    }
    catch (err) {
        console.log(err);
    }
}

export const getAllSchedule = async () => {
    try {
        return await axiosMainUrl.get("/schedule");
    }
    catch (err) {
        console.log(err);
    }
}

export const getAllHolidays = async () => {
    try {
        return await axiosMainUrl.get("/holiday/all");
    }
    catch (err) {
        console.log(err);
    }
}

export const sendSchedulePost = async (form) => {
    try {
        return await axiosMainUrl.post("/schedule/create", form);
    }
    catch (err) {
        console.log(err);
    }
}

export const sendScheduleHolidayPost = async (form) => {
    try {
        return await axiosMainUrl.post("/holiday/create", form);
    }
    catch (e) {
        console.log(e);
    }
}

export const sceduleDelete = async (scheduleId) => {
    try {
        return await axiosMainUrl.delete(`/schedule/delete/${scheduleId}`);
    }
    catch (err) {
        console.log(err);
    }
}

export const holidayDelete = async (holidayId) => {
    try {
        return await axiosMainUrl.delete(`/holiday/delete/${holidayId}`);
    }
    catch (err) {
        console.log(err);
    }
}